import React from 'react';

const portfolioItems = [
  {
    category: 'Pet Portrait',
    title: 'Green-Eyed Gaze',
    image: '/assets/portfolio/cat-black-and-white.jpg',
    alt: 'Black and white portrait of a tabby cat with striking eyes resting on an office chair'
  },
  {
    category: 'Landscape',
    title: 'Sunset Over the Marsh',
    image: '/assets/portfolio/lake-sunset.jpg',
    alt: 'Sun setting through trees over a calm marsh, with reeds silhouetted in the foreground'
  },
  {
    category: 'Pet Portrait',
    title: 'Window Light',
    image: '/assets/portfolio/long-haired-cat.jpg',
    alt: 'Close portrait of a long-haired tabby cat in warm indoor light'
  },
  {
    category: 'Nature',
    title: 'Daylilies',
    image: '/assets/portfolio/yellow-lilies.jpg',
    alt: 'Two yellow daylilies in full bloom against long green leaves'
  },
];

const Portfolio = () => {
  return (
    <section id="portfolio" className="section section--dark" aria-labelledby="portfolio-title">
      <div className="container">
        <header className="section__header">
          <span className="section__tagline">My Style</span>
          <h2 id="portfolio-title" className="section__title">Portfolio</h2>
          <p className="section__description">
            Personal work I've shot around home and the Oakville waterfront. It's where I
            practice reading light, composing a frame, and editing with care, and I bring the
            same approach to every client shoot.
          </p>
        </header>
        <div className="portfolio__grid" role="list">
          {portfolioItems.map((item, index) => (
            <article key={index} className="portfolio__item" role="listitem" tabIndex={0}>
              <img 
                src={item.image} 
                alt={item.alt}
                className="portfolio__image"
                loading={index < 3 ? 'eager' : 'lazy'}
              />
              <div className="portfolio__overlay">
                <span className="portfolio__category">{item.category}</span>
                <h3 className="portfolio__title">{item.title}</h3>
              </div>
            </article>
          ))}
        </div>
        <div className="portfolio__cta">
          <a href="#contact" className="btn btn--outline-white">
            Book Your Shoot
          </a>
        </div>
      </div>
    </section>
  );
};

export default Portfolio;